<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Header -->

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full overflow-hidden" *transloco="let t">

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <div [style.height.px]="stickyFooter ? footerHeight : null"></div>
    <div #appFooter [ngClass]="stickyFooter ? 'fixed bottom-0 left-0' : 'relative'"
         class="flex flex-0 justify-center w-full px-6 md:px-8 z-49 border-t bg-card print:hidden">
        <div class="flex items-center w-full max-w-360 h-8 sm:h-8">
            <languages class="flex-none"></languages>
            <span class="font-medium text-secondary flex-auto w-2/4">
                <a [href]="landing.href('about')" class="text-white" *ngIf="!mobile">{{t('footer-contact-support')}}</a>
                <!-- Mobil reicht "Support" (in DE und EN gleich), sonst bricht die Zeile um -->
                <a [href]="landing.href('about')" class="text-white" *ngIf="mobile">Support</a>
            </span>
            <span class="font-small text-md whitespace-nowrap">
                <a href="https://sweetpopcorn.studio" target="_blank" *ngIf="!mobile">SweetPopcorn.Studio
                    &copy;{{currentYear}}</a>
                <a href="https://sweetpopcorn.studio" target="_blank" *ngIf="mobile">SPS &copy;{{currentYear}}</a>
            </span>
            <div class="font-small text-md pl-4">v{{ appVersion }}</div>
        </div>
    </div>

</div>
